import * as React from "react";
import { SVGProps } from "react";

export const MayContainIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <rect width={16} height={16} fill="#fff" rx={8} />
      <rect
        width={2}
        height={20}
        x={2.222}
        y={3.636}
        fill="#FF1A5E"
        rx={1}
        transform="rotate(-45 2.222 3.636)"
      />
    </g>
    <rect
      width={14}
      height={14}
      x={1}
      y={1}
      stroke="#FF1A5E"
      strokeDasharray="4 4"
      strokeWidth={2}
      rx={7}
    />
    <defs>
      <clipPath id="a">
        <rect width={16} height={16} fill="#fff" rx={8} />
      </clipPath>
    </defs>
  </svg>
);
